/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:576px){#subscriptionFrame[_ngcontent-%COMP%]{width:92%}}"];
export { styles as styles };
